/**
 * Ephemeral hand-off between the root native-overlay listener and whichever
 * authenticated conversation route is mounted. It intentionally stores only
 * function references: no text, response, account, session, or token is put
 * in local/session storage, an Intent, or a native preference.
 */
const handlers = new Set();

export function registerAthenaQuickOverlayMessageHandler(handler) {
  if (typeof handler !== 'function') return () => {};
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export async function submitAthenaQuickOverlayMessage(payload) {
  const candidates = Array.from(handlers);
  const handler = candidates[candidates.length - 1];
  if (typeof handler !== 'function') {
    return {
      accepted: false,
      response: 'Abra a Athena e tente novamente. A conversa atual ainda não está pronta.',
    };
  }

  try {
    const result = await handler(payload);
    return result && typeof result === 'object'
      ? result
      : { accepted: false, response: 'Não consegui concluir esta mensagem agora.' };
  } catch {
    return {
      accepted: false,
      response: 'Não consegui concluir esta mensagem agora. Abra a Athena e tente novamente.',
    };
  }
}
